import React from 'react';
import { X, Play } from 'lucide-react';
import { Cut, Label, Names } from './Cut';
import { filmTypeLabel } from './theatreUtils';

export const LibraryModal = ({ films, allCount, tags, selectedTags, onToggleTag, onClearTags, onPick, currentIndex, playing, onClose }) => (
  <div className="theatre th-ground fixed inset-0 z-50 overflow-y-auto th-scroll th-fade" data-testid="film-library-modal">
    <div className="min-h-screen px-5 md:px-12 py-10 md:py-16">
      <div className="flex items-start justify-between gap-6">
        <div className="th-rise">
          <Label>Film library</Label>
          <h2 className="th-display font-light text-4xl md:text-5xl mt-2">Every film, one place</h2>
          <p className="th-caption mt-2" data-testid="film-library-count">{allCount} films</p>
        </div>
        <button type="button" onClick={onClose} className="th-icon-btn flex-shrink-0" aria-label="Close library" data-testid="film-library-close"><X size={22} /></button>
      </div>
      <hr className="th-rule th-draw my-8" />
      <div className="flex flex-wrap gap-2 mb-10" data-testid="film-library-filters">
        <span className={`th-frame th-cut th-cut-sm inline-flex ${selectedTags.length === 0 ? 'is-active' : ''}`}>
          <button type="button" onClick={onClearTags} className="th-cut th-cut-sm th-solid th-chip min-h-[40px] text-[11px]" data-testid="film-library-tag-all"><span className="th-chip-dot" />All</button>
        </span>
        {tags.map((tag) => (
          <span key={tag.id} className={`th-frame th-cut th-cut-sm inline-flex ${selectedTags.includes(tag.name) ? 'is-active' : ''}`}>
            <button type="button" onClick={() => onToggleTag(tag.name)} className="th-cut th-cut-sm th-solid th-chip min-h-[40px] text-[11px]" data-testid={`film-library-tag-${tag.name}`}>
              <span className="th-chip-dot" />{tag.display_name}
            </button>
          </span>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="film-library-grid">
        {films.map((film, index) => {
          const isCurrent = playing && currentIndex === index;
          return (
            <button key={film.id} type="button" onClick={() => onPick(index)} className="group text-left th-rise" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }} data-testid={`film-library-item-${film.id}`}>
              <Cut size="md" active={isCurrent} glow={isCurrent}>
                <div className="relative aspect-video overflow-hidden">
                  {film.thumbnail_url ? (
                    <img src={film.thumbnail_url} alt={film.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" loading="lazy" decoding="async" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center th-caption">No still yet</div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'rgba(7,6,5,0.35)' }}>
                    <span className="th-ring w-14 h-14" style={{ background: 'rgba(27,23,20,0.6)' }}><Play size={20} strokeWidth={1.5} style={{ color: 'var(--th-accent)' }} className="ml-0.5" /></span>
                  </div>
                  {isCurrent && (
                    <span className="absolute top-3 left-3 th-label text-[9px] px-2 py-1 th-solid flex items-center gap-2" data-testid="film-library-now-playing">
                      <span className="w-1 h-1" style={{ background: 'var(--th-accent)' }} />Now playing
                    </span>
                  )}
                </div>
                <div className="px-5 py-4">
                  <Label className="text-[9px]">{filmTypeLabel(film)}</Label>
                  <Names text={film.title} className="text-2xl font-light tracking-[0.06em] block mt-1 group-hover:text-[#ecd6b4] transition-colors duration-500" />
                  {film.subtitle && <p className="th-caption mt-1">{film.subtitle}</p>}
                </div>
              </Cut>
            </button>
          );
        })}
      </div>
      {films.length === 0 && (
        <div className="text-center py-20">
          <p className="th-caption">No films match this filter</p>
          <button type="button" onClick={onClearTags} className="th-btn th-btn-text mt-2">Clear filters</button>
        </div>
      )}
    </div>
  </div>
);
